import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Web3ContextProvider } from './hooks/web3Context';
import store from './store';

ReactDOM.render(
  <React.StrictMode>
    <Web3ContextProvider>
      <Provider store={store}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </Provider>
    </Web3ContextProvider>
  </React.StrictMode>,
  document.getElementById('root'),
);

reportWebVitals();
